import React from 'react';
import { toast, ToastContainer, ToastOptions } from 'react-toastify';

const OncolensToast = () => (
  <ToastContainer position={toast.POSITION.TOP_RIGHT} hideProgressBar={true} theme="colored" />
);

OncolensToast.success = (message: string, options?: ToastOptions<Record<string, unknown>>) => {
  toast.success(<div className="mx-2">{message}</div>, {
    bodyClassName: 'py-3',
    ...options,
  });
};

OncolensToast.error = (message: string, options?: ToastOptions<Record<string, unknown>>) => {
  toast.error(<div className="mx-2">{message}</div>, {
    bodyClassName: 'py-3',
    ...options,
  });
};

export { OncolensToast as default };
